import AuthenticationLayout from 'components/AuthLayout';
import Button from 'components/Button';
import Typography from 'components/Typography';
import { FC } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Subtitle = styled.div`
  margin-top: 2.25rem;
  font-size: 1rem;
  text-align: justify;
  p {
    margin-bottom: 1rem;
    color: var(--gray-700);
  }
  width: 60rem;
  max-width: 100%;

  h1 {
    color: black;
    margin-bottom: 1rem;
  }
`;

const SignupPage: FC = () => {
  return (
    <AuthenticationLayout title="Inscriptions" backTo="/" src_image="/logo_institut_principal.png">
      <Subtitle>
        <Typography variant="h1">Inscription mentoré</Typography>
        <p>
          Vous êtes un jeune en service civique, ou vous venez de le terminer ?
          Vous pouvez alors vous inscrire afin de bénéficier du mentorat avec
          l'Institut de l'Engagement.
        </p>
        <p>
          Pour commencer votre inscription en tant que mentoré, cliquez sur le
          bouton ci-dessous.
        </p>
      </Subtitle>
      <Link to="/mentee/signup">
        <Button color="primary">Bénéficier du mentorat</Button>
      </Link>
      <Subtitle>
        <Typography variant="h1">Inscription mentor</Typography>
        <p>
          Vous avez des connaissances dans un domaine et souhaitez les partager
          à des jeunes engagés ? Vous pouvez alors vous inscrire, où vous serez
          mis en relation avec des jeunes, afin de leur apporter votre aide.
        </p>
        <p>
          Pour commencer votre inscription en tant que mentor, cliquez sur le
          bouton ci-dessous.
        </p>
      </Subtitle>
      <Link to="/mentor/signup">
        <Button color="primary">Devenir mentor de jeunes engagés</Button>
      </Link>
    </AuthenticationLayout>
  );
};

export default SignupPage;
